class NavigationItem {
  constructor ({label, href, active = false, params = null, query = null}) {
    this.label = label
    this.href = href
    this.active = active
    this.params = params
    this.query = query
    // Définition d'un alias de text vers label
    Object.defineProperty(this, 'text', {
      get: function () {
        return this.label
      },
      enumerable: true,
      configurable: true
    })
  }
  isActive () {
    return this.active === true
  }
}

export default NavigationItem



// WEBPACK FOOTER //
// ./src/lib/transfer-objects/NavigationItem.js